import { createSlice } from '@reduxjs/toolkit';

export const changePasswordSlice = createSlice({
    name: 'ChangePassword',
    initialState: {
        isOpen: false
    },
    reducers: {
        openChangePassword: (state) => {
            state.isOpen = true;
        },
        close: (state) => {
            state.isOpen = false;
        },
    },
})

export const { openChangePassword, close } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;